import {
  getPreferredCommunicationOptions,
  getSalutationOptions,
} from '../../../api'

import { USER_PROFILE_SALUTATION_OPTIONS_API_PARAMS } from './UserProfileWidget.constants'

export function getUserProfilePreferredCommunicationOptionsData(params) {
  return getPreferredCommunicationOptions({ params })
}

export function getUserProfileSalutationOptionsData(params) {
  return getSalutationOptions({
    params: { ...params, ...USER_PROFILE_SALUTATION_OPTIONS_API_PARAMS },
  })
}
